import { render, staticRenderFns } from "./FeedingForm.vue?vue&type=template&id=81b81d54&scoped=true&"
import script from "./FeedingForm.vue?vue&type=script&lang=js&"
export * from "./FeedingForm.vue?vue&type=script&lang=js&"
import style0 from "./FeedingForm.vue?vue&type=style&index=0&id=81b81d54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81b81d54",
  null
  
)

export default component.exports